import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { Venue } from '../models/venue';
import { environment } from '../../environments/environment';
import { VenueContextService } from '../services/venue-context.service';
import { VenueDataService } from '../services/venue-data.service';

@Component({
    selector: 'app-sidebar',
    imports: [CommonModule, RouterModule],
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent {
  private router = inject(Router);
  private venueContext = inject(VenueContextService);

  readonly isMobileOpen = input<boolean>(false);
  venues$: Observable<Venue[]> = inject(VenueDataService).getVenues();
  isDropdownOpen: boolean = false;

  get venueId(): string | null {
    return this.venueContext.venueId();
  }

  get venueName(): string {
    return this.venueContext.venue()?.name ?? 'Menu';
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectVenue(venue: Venue) {
    if (venue.id) {
      this.router.navigate(['/venues', venue.id]);
      this.isDropdownOpen = false;
    }
  }

  getPortalEditUrl(venueID: string): string {
    return `${environment.portalBaseUrl}/home/realtimereports/${venueID}`;
  }

  getPortalSponsorshipsUrl(venueID: string): string {
    return `${environment.portalBaseUrl}/home/edit/${venueID}/sponsorships`;
  }

  getPortalMenuItemsUrl(): string {
    return `${environment.portalBaseUrl}/home/menus/J9O2aq83ygJzdz03Yz5a/items`;
  }
}
